import React from 'react';

/**
 * Formats the call-to-action text by replacing newline characters with <br /> elements.
 *
 * The formatCallToActionText function processes the input string "GET CNBC\nALL ACCESS" as follows:
 * 1. Matches the parts of the string separated by newline characters.
 * 2. Maps over the matches to create JSX elements, inserting <br /> elements where needed.
 * 3. Returns the formatted text as a JSX element.
 *
 * Example:
 * Input: "GET CNBC\nALL ACCESS"
 * Output:
 * <>
 *   GET CNBC
 *   <br />
 *   ALL ACCESS
 * </>
 *
 * @param {string} text - The call-to-action text to format.
 * @returns {JSX.Element} - The formatted text as a JSX element.
 */
const formatCallToActionText = (text) => {
  // return null if the input text is falsy (i.e. null, undefined, empty string)
  if (!text) return null;

  // apply regex to split the text into parts
  // no newline? that means there's no match, use the entire text as a single part
  const [_, ...matches] = text.match(/(.+)(\n)(.+)/) || [null, text];

  // after, map over the matches to create JSX elements
  // check newline, insert a <br /> element
  // otherwise, wrap the text in a React.Fragment
  const textWithLineBreakElement = matches.map((match, index) =>
    match === '\n' ? (
      <br key={index} />
    ) : (
      <React.Fragment key={index}>{match}</React.Fragment>
    ),
  );

  return textWithLineBreakElement;
};

export default formatCallToActionText;
